"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Color = require("../core/Color");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition: opacity 200ms ease;\n  opacity: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getBoxShadow = function getBoxShadow(boxShadow, radius, color) {
  if (typeof boxShadow === 'string') return boxShadow;
  return boxShadow === true ? "0 0 " + radius + "px " + (0, _Color.rgba)(color, 0.5) : undefined;
};

var NanoProgressTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "UINanoProgress__NanoProgressTransitionWrapper",
  componentId: "sc-8wp5ld-0"
})(_templateObject(), function (_ref) {
  var closing = _ref.closing;
  return closing ? 0 : 1;
});

var Bar = _styledComponents.default.div.withConfig({
  displayName: "UINanoProgress__Bar",
  componentId: "sc-8wp5ld-1"
})(_templateObject2(), _sizes.MERCURY_LAYER);

var _default = _react.default.createClass({
  displayName: "UINanoProgress",
  propTypes: {
    animateOnComplete: _react.PropTypes.bool,
    boxShadow: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
    color: _react.PropTypes.string,
    height: _react.PropTypes.number,
    value: _react.PropTypes.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      animateOnComplete: false,
      boxShadow: true,
      color: _colors.SORBET,
      height: 2,
      value: 0
    };
  },
  render: function render() {
    var _this$props = this.props,
        animateOnComplete = _this$props.animateOnComplete,
        boxShadow = _this$props.boxShadow,
        className = _this$props.className,
        color = _this$props.color,
        height = _this$props.height,
        value = _this$props.value;
    return value >= 0 && _react.default.createElement(_TwoWayTransition.default, {
      duration: 200,
      Wrapper: NanoProgressTransitionWrapper,
      className: className
    }, animateOnComplete && value >= 100 ? null : _react.default.createElement(Bar, {
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": value,
      role: "progressbar",
      style: {
        width: value + "%",
        background: color,
        boxShadow: getBoxShadow(boxShadow, height * 3, color),
        height: height,
        transition: 'all 200ms ease'
      }
    }));
  }
});

exports.default = _default;
module.exports = exports.default;